<template>
  <v-dropdown-menu
    text="word.register"
    :style-type="styleType"
    :block="true"
  >
    <template v-slot:menu>
      <button
        class="dropdown-item"
        type="button"
        @click="$emit('selected', 'user')"
      >
        <i class="fa fa-user mr-2"></i> {{ $t('phrase.as_reviewer') }}
      </button>
      <button
        class="dropdown-item"
        type="button"
        @click="$emit('selected', 'organisation')"
      >
        <i class="fa fa-building mr-2"></i> {{ $t('phrase.as_organisation') }}
      </button>
    </template>
  </v-dropdown-menu>
</template>

<script>
import DropdownMenu from '@/common/components/DropdownMenu.vue';

export default {
  name: 'RegisterDropdown',
  components: {
    'v-dropdown-menu': DropdownMenu,
  },
  props: {
    styleType: {
      type: String,
      default() {
        return 'secondary';
      },
    },
  },
};
</script>
